/* eslint-disable react/prop-types */
import IconButton from 'components/custom/ui/IconButton';
import Icon from 'components/icon';
import { Modal } from 'react-bootstrap';

const CustomAlert = ({
  show,
  handleClose,
  message,
  variant = 'danger',
  icon = 'fluent:warning-32-filled'
}) => {
  return (
    <Modal
      // size="sm"
      show={show}
      onHide={handleClose}
      contentClassName="bg-soft"
      aria-labelledby="example-modal-sizes-title-sm"
    >
      {/* <Modal.Header>
        <Modal.Title id="example-modal-sizes-title-sm">Small Modal</Modal.Title>
        <CloseButton onClick={handleClose} />
      </Modal.Header> */}
      <Modal.Body className={`text-${variant}`}>
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1">
            <div className={`text-${variant}`}>
              <Icon icon={icon} fontSize={'30px'} />
            </div>
            <p className="mb-0">{message}</p>
          </div>
          <div className="d-flex">
            <IconButton
              onClick={handleClose}
              size="sm"
              className="ms-auto rounded-circle border-0"
              variant={`outline-${variant} `}
              icon={'icon-park-outline:close'}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CustomAlert;
